// Pure helpers shared by every Planner view — quarter math, initials,
// and the date formatter the cards / lists use.

export function currentQuarter(d: Date = new Date()): string {
  const q = Math.floor(d.getMonth() / 3) + 1;
  return `${d.getFullYear()}-Q${q}`;
}

export function quarterRange(quarter: string): { start: Date; end: Date } {
  const [yearStr, qStr] = quarter.split("-Q");
  const year = Number(yearStr);
  const q = Number(qStr);
  const startMonth = (q - 1) * 3;
  return {
    start: new Date(year, startMonth, 1),
    end: new Date(year, startMonth + 3, 0, 23, 59, 59, 999),
  };
}

export function nextQuarter(quarter: string): string {
  const [yearStr, qStr] = quarter.split("-Q");
  const year = Number(yearStr);
  const q = Number(qStr);
  if (q === 4) return `${year + 1}-Q1`;
  return `${year}-Q${q + 1}`;
}
export function prevQuarter(quarter: string): string {
  const [yearStr, qStr] = quarter.split("-Q");
  const year = Number(yearStr);
  const q = Number(qStr);
  if (q === 1) return `${year - 1}-Q4`;
  return `${year}-Q${q - 1}`;
}

export function initials(name: string | null): string {
  if (!name) return "··";
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
}

export function formatDateShort(d: Date | null): string {
  if (!d) return "—";
  return d.toLocaleDateString("en-AU", {
    day: "2-digit",
    month: "short",
    year: "2-digit",
  });
}

export function isOverdue(d: Date | null, status: string | undefined): boolean {
  if (!d) return false;
  if (status === "done" || status === "cancelled") return false;
  return d.getTime() < Date.now();
}

export function statusChipClass(status: string): string {
  switch (status) {
    case "on_track":
    case "done":
      return "bsp-chip bsp-chip-green";
    case "off_track":
    case "missed":
    case "blocked":
      return "bsp-chip bsp-chip-red";
    case "in_progress":
    case "discussing":
    case "actioned":
      return "bsp-chip bsp-chip-blue";
    case "draft":
    case "open":
      return "bsp-chip bsp-chip-grey";
    case "cancelled":
    case "archived":
    case "converted":
      return "bsp-chip bsp-chip-grey";
    default:
      return "bsp-chip bsp-chip-grey";
  }
}

export function priorityChipClass(priority: string): string {
  switch (priority) {
    case "critical":
      return "bsp-chip bsp-chip-red";
    case "high":
      return "bsp-chip bsp-chip-orange";
    case "medium":
      return "bsp-chip bsp-chip-blue";
    case "low":
    default:
      return "bsp-chip bsp-chip-grey";
  }
}

export function ragClass(rag: "green" | "amber" | "red" | "neutral"): string {
  return `bsp-chip tp-rag-${rag}`;
}
